// extracted by mini-css-extract-plugin
module.exports = {"alert":"AccountDataForm__alert___1wFCX","music-container":"AccountDataForm__music-container___QYh2g"};